export const Accordion = (() => {
	'use strict';
	let $accordion_toggle;

	function init() {
		$accordion_toggle = $(".pxblock--accordion .toggle");

		if ($accordion_toggle) {
			events();
		}
	}

	function events() {
		$accordion_toggle.click(function (e) {
			e.preventDefault();

			let $t = $(this),
				$tab = $t.closest('.accordion--tab');
			if ($tab.hasClass('expanded')) {
				$tab.removeClass('expanded');
				$tab.find('.content').stop().slideUp();
				$t.attr('aria-expanded', 'false');
			} else {
				$tab.addClass('expanded');
				$tab.find('.content').stop().slideDown();
				$t.attr('aria-expanded', 'true');
			}
		});
	}
	return {
		init: init,
		name: 'accordion'
	};
})();
